import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_VALIDATION_LANG: {
  VALIDATION_IN_PROGRESS_MESSAGE: MvnCodeFE;
  VALIDATION_ISSUE_REPORT: MvnCodeFE;
  VALIDATION_ISSUE_CHECK: MvnCodeFE;
  VALIDATION_ISSUE_REPORT_EXPORT_SUCCEED: MvnCodeFE;
  VALIDATION_ISSUE_REPORT_EXPORT_FAILED: MvnCodeFE;
  VALIDATION_ISSUE_CHECK_SUCCEED: MvnCodeFE;
  VALIDATION_ISSUE_CHECK_FAILED: MvnCodeFE;
  VALIDATION_MESSAGE_DIALOG_TITLE: MvnCodeFE;
  VALIDATION_MESSAGE_REQUIRED: MvnCodeFE;
  VALIDATION_MESSAGE_INVALID: MvnCodeFE;
  VALIDATION_EXCLUDED_DATASET_TOOLTIP: MvnCodeFE;
} = {
  VALIDATION_IN_PROGRESS_MESSAGE: {
    ko: "검증 진행 중입니다.\n종료될 때까지 기다려 주세요.",
    en: "Validation is in progress.\nPlease wait until it is complete.",
  },

  VALIDATION_ISSUE_REPORT: {
    ko: "이슈 보고서",
    en: "Issue Report",
  },

  VALIDATION_ISSUE_CHECK: {
    ko: "유효성 검사",
    en: "Validation",
  },

  VALIDATION_ISSUE_REPORT_EXPORT_SUCCEED: {
    ko: "결과 패키지 압축 파일 다운로드를 완료했습니다.",
    en: "The result package zip file has been successfully downloaded.",
  },

  VALIDATION_ISSUE_REPORT_EXPORT_FAILED: {
    ko: "결과 패키지 압축 파일 다운로드에 실패했습니다.",
    en: "Failed to download the result package zip file.",
  },

  VALIDATION_ISSUE_CHECK_SUCCEED: {
    ko: "유효성 검사를 완료했습니다.",
    en: "Validation has been completed.",
  },

  VALIDATION_ISSUE_CHECK_FAILED: {
    ko: "유효성 검사에 실패했습니다.",
    en: "Failed to validation.",
  },

  VALIDATION_MESSAGE_DIALOG_TITLE: {
    ko: "다음 오류를 확인하십시오.",
    en: "Please check the following error.",
  },

  VALIDATION_MESSAGE_REQUIRED: {
    ko: "{category} Tab {property} 값을 확인해주세요.",
    en: "{category} Tab {property} is required.",
  },

  VALIDATION_MESSAGE_INVALID: {
    ko: "{category} Tab {recognizableVariable} 의 {property} 값이 유효하지 않습니다.",
    en: "{category} Tab {property} of {recognizableVariable} is invalid.",
  },
  VALIDATION_EXCLUDED_DATASET_TOOLTIP: {
    ko: "데이터 동기화(재흐름 또는 재저장)가 필요하여 Validation 대상에서 제외됩니다.",
    en: "Excluded from validation targets as data synchronization (re-flow or re-save) is required.",
  },
};

MvnCodeInitiate(CONVERTER_VALIDATION_LANG);
